module.exports = __webpack_public_path__ + "960bd3f809387c5b43c2cf32328c730a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/i/i36.jpg
// module id = 640
// module chunks = 0